<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button type="primary" icon="plus" v-action:add @click="handleAdd" class="ml-4">新建管理员</a-button>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />

          </div>
        </standard-form-row>

      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false" title="管理员列表">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="avatar" slot-scope="text">
          <a-avatar :src="text ? globalUrl + text : '/user.jpg'" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-tooltip title="设置权限" v-action:update @click="() => handleEditRole(record.id)">
            <a><a-icon type="edit" /> 编辑</a>
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="重置密码" v-action:reset>
            <a-popconfirm
              title="确定重置密码吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleResetPassWord(record.id)"
            >
              <a><a-icon type="lock" /> 重置密码</a>
            </a-popconfirm>
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="删除" v-action:delete>
            <a-popconfirm
              title="确定删除吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleOnDelete(record.id)"
            >
              <a><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </a-tooltip>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList } from '@/components'
import ModelForm from './modules/ModelForm'
import { requestPatch } from '@/api/api'
const apiList = {
    getList: '/admins/users',
    delete: '/admins/users/',
    changeState: '/admins/users/'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '账号',
        dataIndex: 'username',
        sorter: true
    },
    {
        title: '姓名',
        dataIndex: 'name',
        align: 'center'
    },
    {
        title: '头像',
        dataIndex: 'avatar',
        align: 'center',
        scopedSlots: { customRender: 'avatar' }
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '更新时间',
        dataIndex: 'updated_at',
        sorter: true
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'UserList',
    mixins: [table, list], // 使用mixins
    components: {
        ModelForm,
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    computed: {
        getTypeMap (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '普通会员', color: 'gold' },
                    2: { value: '教师', color: '#f50' },
                    3: { value: '机构', color: 'green' }
                }
                return statusMap[status]
            }
        },
        getRealAuthMap (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '已认证', color: 'green' },
                    2: { value: '未认证', color: '#eee' },
                    3: { value: '待审核', color: 'gold' },
                    4: { value: '已驳回', color: '#f50' }
                }
                return statusMap[status]
            }
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {
        /**
         * 弹窗添加
         * ModelForm
         */
        handleAdd () {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    record: {},
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '创建管理员',
                    centered: true,
                    okText: '提交',
                    width: 700,
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        handleEditRole (aid) {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    aid,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '管理员编辑',
                    centered: true,
                    width: 700,
                    maskClosable: false
                }
            )
        },
        /**
         * 重置密码
         * id
         * @param
         * @JDY
         * @2020-11-17
         */
        handleResetPassWord (id) {
            requestPatch('/admins/users/password/' + id)
                .then(res => {
                    this.$notification.success({
                        message: res.msg,
                        description: '密码重置为osctraining'
                    })
                })
        }

    }
}
</script>

<style lang="less" scoped>
.screenfull {
    background: #fff;
}
.change-state {
    margin-bottom: 16px;
    text-align: right;
    & > * {
        margin-left: 15px;
    }
}
.new-btn {
    background-color: #fff;
    border-radius: 2px;
    width: 100%;
    height: 188px;
}
.ant-pro-page-header-search {
    text-align: center;
    margin-bottom: 16px;
}
/deep/.antd-pro-components-standard-form-row-index-standardFormRow {
    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border: none;
    }
}
.ant-pro-components-tag-select {
    /deep/ .ant-pro-tag-select .ant-tag {
        margin-right: 24px;
        padding: 0 8px;
        font-size: 14px;
    }
}

/deep/.ant-card-cover {
    div {
        text-align: center;
        img {
            width: 100%;
        }
    }
}
.button-color-success {
    background-color: #62ea9f;
    border-color: #62ea9f;
}
</style>
